require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-2018-06-21-gems-distribution.json") })
        }
      }, "path---blog-2018-06-21-gems-distribution");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-2018-06-21-gems-distribution!./.cache/json/blog-2018-06-21-gems-distribution.json
// module id = 336
// module chunks = 231608221292675